<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Off Payroll Workers (IR35)</h1>
    <p>Do you process payroll for any workers who are deemed as an off payroll worker under IR35?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasOffPayrollWorkers">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasOffPayrollWorkers">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasOffPayrollWorkers === undefined || props.formData.hasOffPayrollWorkers === null || props.formData.hasOffPayrollWorkers === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}




const executeStep = async () => {
  return true;
}





defineExpose({ validateStep, executeStep });

</script>